<div class="h-auto p-2 w-full bg-white rounded-lg mb-4 border-[1px] border-border flex flex-wrap gap-2 justify-between items-center">
    <app-logo height="40" width="90" class="ml-2" class="hover:cursor-pointer" (click)="openDashboard()"></app-logo>
    <div class="mr-2 flex gap-2 items-center">
        <div class="relative inline-block" #popupContainer>
            <button (click)="togglePopup()" class="relative">
              <img class="w-[40px] h-[40px]" alt="Notifications" src="assets/icons/notifications.svg">
              <span *ngIf="unreadCount > 0"
                class="absolute top-0 right-0 bg-error text-white text-xs rounded-full px-1.5 py-0.5">
                {{ unreadCount }}
              </span>
            </button>
      
            <app-notifications-popup *ngIf="showPopup" [notifications]="notifications" (markAsRead)="markAsRead($event)"
              [loadMore]="loadMoreCallback" [waitingForNextPageResponse]="waitingForNextPage">
            </app-notifications-popup>
          </div>

        <div class="w-[40px] h-[40px]">
            <app-custom-avatar [initials]="userInitials" [imageUrl]="getProfileImage"></app-custom-avatar>
        </div>
        <app-mobile-drawer [selectedItemId]="selectedItemId"></app-mobile-drawer>
    </div>
</div>